var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChildreneducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1054_26092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.05562 12.9412L5.29987 7.08847C5.34788 6.86269 5.2028 6.64095 4.97587 6.59318C4.74893 6.54542 4.52605 6.68975 4.47804 6.91553L3.23379 12.7682C3.18578 12.994 3.33085 13.2158 3.55779 13.2635C3.78473 13.3113 4.00761 13.167 4.05562 12.9412ZM15.7669 7.08984L17.0338 12.9469C17.0826 13.1726 17.306 13.3161 17.5328 13.2675C17.7595 13.219 17.9038 12.9967 17.855 12.7711L16.5881 6.91402C16.5393 6.6884 16.3159 6.54487 16.0891 6.59343C15.8624 6.64199 15.7181 6.86424 15.7669 7.08984Z",
    fill: "#858991"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8403 4.68008L10.9902 1.03248C10.7726 0.942729 10.3633 0.941851 10.1451 1.03069L1.18583 4.68006L10.1453 8.32931C10.3632 8.41817 10.7725 8.41731 10.9904 8.32758L19.8403 4.68006V4.68008ZM11.3118 9.0997C10.8892 9.2738 10.2498 9.27514 9.82686 9.10266L0.501193 5.30426C-0.167095 5.03169 -0.167095 4.32802 0.501378 4.05583L9.8269 0.257284C10.2502 0.0849175 10.8896 0.0862639 11.3118 0.260466L20.5165 4.05415C21.1823 4.32841 21.1823 5.03173 20.5165 5.30597L11.3118 9.0997ZM17.2319 12.4982C15.2221 13.6727 12.932 14.301 10.5486 14.301C8.16226 14.301 5.8695 13.6712 3.85801 12.494C3.65808 12.377 3.40067 12.4434 3.28306 12.6423C3.16545 12.8412 3.23218 13.0973 3.43211 13.2143C5.57181 14.4666 8.01144 15.1367 10.5486 15.1367C13.0826 15.1367 15.5194 14.4682 17.6573 13.2188C17.8573 13.1019 17.9242 12.8459 17.8067 12.6469C17.6892 12.4479 17.4319 12.3813 17.2319 12.4982Z",
    fill: "#858991"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1777 4.60145V10.6455C20.1777 10.8763 20.3658 11.0634 20.5977 11.0634C20.8297 11.0634 21.0177 10.8763 21.0177 10.6455V4.60145C21.0177 4.37067 20.8297 4.18359 20.5977 4.18359C20.3658 4.18359 20.1777 4.37067 20.1777 4.60145Z",
    fill: "#858991"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1054_26092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildreneducation);
export default __webpack_public_path__ + "static/media/childreneducation.a38da0cb38ffb4954f4ca9d57d0d4803.svg";
export { ForwardRef as ReactComponent };